<template>
    <div class="vx-col w-full mb-base">
      <vx-card>
        <!-- NOMBRE Y APELLIDO -->
        <div class="vx-row">
            <div class="vx-col sm:w-1/2 w-full">
                <vs-input icon-pack="feather" icon="icon-user" label="Nombre" placeholder="" v-model="name" class="mt-5 w-full" name="name" v-validate="'required'" />
                <span class="text-danger text-sm" v-show="errors.has('name')">{{ errors.first('name') }}</span>
            </div>
            <div class="vx-col sm:w-1/2 w-full">
                <vs-input icon-pack="feather" icon="icon-user" label="Apellido" placeholder="" v-model="surname" class="mt-5 w-full" name="surname" v-validate="'required'" />
                <span class="text-danger text-sm" v-show="errors.has('surname')">{{ errors.first('surname') }}</span>
            </div>
        </div>
        <!-- EMAIL, PASSWORD Y CONFIRMATION PASSWORD -->
        <div class="vx-row">
            <div class="vx-col sm:w-1/3 w-full">
                <vs-input icon-pack="feather" icon="icon-mail" label="Email" v-model="email" class="mt-5 w-full" name="email" v-validate="'required|email'" />
                <span class="text-danger text-sm" v-show="errors.has('email')">{{ errors.first('email') }}</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full ">
                <vs-input icon-pack="feather" icon="icon-lock" label="Contraseña" v-model="password" class="mt-5 w-full" name="password" v-validate="'required|min:8|max:15'" />
                <span class="text-danger text-sm" v-show="errors.has('password')">{{ errors.first('password') }}</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
                <vs-input icon-pack="feather" icon="icon-lock" label="Repetir contraseña" v-model="password_confirmation" class="mt-5 w-full" name="password_confirmation" v-validate="'min:8|max:15|confirmed:password'" />
                <span class="text-danger text-sm" v-show="errors.has('password_confirmation')">{{ errors.first('password_confirmation') }}</span>
            </div>
        </div>
        <!-- TELÉFONO MÓVIL y SEDE -->
        <div class="vx-row">
            <div class="vx-col sm:w-1/2 w-full">
                <vs-input icon-pack="feather" icon="icon-phone" label="Teléfono Móvil" v-model="mobile_phone" class="mt-4 w-full" name="mobile_phone" v-validate="'required'" />
                <span class="text-danger text-sm" v-show="errors.has('mobile_phone')">{{ errors.first('mobile_phone') }}</span>
            </div>
            <div class="vx-col sm:w-1/2 w-full mt-4">
                <label class="vs-input--label">Sede</label>
                <v-select :closeOnSelect="true" v-model="headquarter_id" label="name_headquarter" :options="headquarters" name="headquarter_id" :reduce="headquarters => headquarters.id_headquarter"></v-select>
            </div>
        </div>
        <!-- DEPARTAMENTO Y ROL  -->
        <div class="vx-row">
          <div class="vx-col sm:w-1/2 w-full mt-4">
            <label class="vs-input--label">Departamento</label>
            <v-select :closeOnSelect="true" v-model="department_id" label="name_department" :options="departments" name="department_id" :reduce="departments => departments.id_department"></v-select>
          </div>
          <div class="vx-col sm:w-1/2 w-full mt-4">
            <label class="vs-input--label">Rol</label>
            <v-select :closeOnSelect="true" v-model="role_id" label="name" :options="roles" name="role_id" :reduce="roles => roles.id"></v-select>
          </div>
        </div>
        <!-- <p>{{ this.role_id }}</p> -->

		<div class="flex flex-wrap items-center justify-end mt-6">
			<vs-button class="ml-auto mt-2" @click="submitData()" :disabled="!isFormValid">Crear Empleado</vs-button>
			<vs-button class="ml-4 mt-2" type="border" color="warning" @click="clearFields()">Limpiar campos</vs-button>
        </div>
        <div class="flex flex-wrap flex justify-between">
            <vs-button  type="flat" to="/admin/empleados" icon-pack="feather" icon="icon-arrow-left">Volver al listado</vs-button>
        </div>

      </vx-card>
    </div>
</template>

<script>
import vSelect from 'vue-select'
// import errorHandling from '@/components/errorHandling.js'

export default {
  components: {
    'v-select': vSelect
  },
  data () {
    return {
      email: '',
      password: '',
      password_confirmation: '',
      name: '', 
      surname: '', 
      headquarter_id: '', 
      mobile_phone: '', 
      department_id: '', 
      name_department: '',
      role_id: '',
      settings: { // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: .60
      }
    }
  },
  computed: {
    departments () {
      return this.$store.state.departments
    },
    headquarters () {
      return this.$store.state.headquarters
    },
    roles () {
      return this.$store.state.roles
    },
    isFormValid () {
      // return true
      return !this.errors.any() && this.email && this.password && this.password_confirmation && this.name && this.surname && this.headquarter_id && this.department_id && this.mobile_phone && this.role_id
    }
  },
  methods: {
    clearFields () {
      this.email = ''
      this.password = ''
      this.password_confirmation = ''
      this.name = ''
      this.surname = '' 
      this.headquarter_id = ''
      this.mobile_phone = ''
      this.department_id = ''
      this.role_id = ''
      // this.errors.clear()

    },
    submitData () {
      this.$validator.validateAll().then(result => {
        if (result) {
          const obj = {
            email: this.email,
            password: this.password,
            password_confirmation: this.password_confirmation,
            name: this.name, 
            surname: this.surname,
            headquarter_id: this.headquarter_id, 
            mobile_phone: this.mobile_phone, 
            department_id: this.department_id, 
            role_id: this.role_id
          }
          this.$vs.loading()
          this.$store
            .dispatch('addEmployee', obj)
            .then(() => { this.$emit('closeSidebar') })
            .then(() => { this.$vs.loading.close() })
            .then(() => {
              this.$vs.notify({
                title: 'Empleado creado',
                text: 'Un empleado ha sido creado',
                color: 'success',
                iconPack: 'feather',
                icon:'icon-check'
              })
              this.clearFields()
            })
            .catch(err => { 
              this.$vs.loading.close()
              console.error(err)
              const mensaje_error = err.response.data.errors
              const array_errors = Object.entries(mensaje_error)
              for (let i = 0; i < array_errors.length; i++) {
                this.$vs.notify({
                  title: 'Registro Fallido',
                  text: `${array_errors[i][1][0]}`,
                  iconPack: 'feather',
                  icon: 'icon-x-circle',
                  color: 'warning',
                  time: 6000
                })
              }
            })
        }
        
      })
    }
  },
  created () {
    this.$store.dispatch('fetchDepartments')
      .catch(err => { 
        // console.log(Object.getOwnPropertyNames(err))
        // console.log(err.response)
        console.error(err)
        this.$vs.notify({
          title: 'Error',
          text:  `${err.response.data.error}`,
          color: 'danger',
          iconPack: 'feather',
          icon:'icon-alert-circle',
          time:6000
        })
      })

    this.$store.dispatch('fetchHeadquarters')
      .catch(err => { 
        // console.log(Object.getOwnPropertyNames(err))
        // console.log(err.response)
        console.error(err)
        this.$vs.notify({
          title: 'Error',
          text:  `${err.response.data.error}`,
          color: 'danger',
          iconPack: 'feather',
          icon:'icon-alert-circle',
          time:6000
        })
      })

    this.$store.dispatch('fetchRoles')
      .catch(err => { 
        // console.log(Object.getOwnPropertyNames(err))
        // console.log(err.response)
        console.error(err)
        this.$vs.notify({
          title: 'Error',
          text:  `${err.response.data.error}`,
          color: 'danger',
          iconPack: 'feather',
          icon:'icon-alert-circle',
          time:6000
        })
      })
  }
}
</script>
